angular.module('westBerkshireEvents.filter').filter('bookingQuestionName', function() {
    return function(questionName) {
        let name = questionName;
        // Strip out the suffix
        name = name.split('(Adult)')[0];
        name = name.split('(Child)')[0];
        return name.trim();
    };
});


// WEBPACK FOOTER //
// src/public/javascripts/filter/booking_question_name.filter.js